/* Desktop uses a vertical strip; retain Dawn's horizontal controls on mobile. */
(function () {
  if (window.wpVerticalThumbnailsBound) return;
  window.wpVerticalThumbnailsBound = true;
  const desktop = window.matchMedia('(min-width: 990px)');
  const selector = 'media-gallery[data-desktop-layout*="thumbnail"]';
  const initialized = new WeakSet();
  function setup(gallery) {
    const slider = gallery.querySelector('.thumbnail-slider');
    const list = slider?.querySelector('.thumbnail-list');
    const prev = slider?.querySelector('.slider-button--prev');
    const next = slider?.querySelector('.slider-button--next');
    if (!list || !prev || !next || initialized.has(list)) return;
    initialized.add(list);
    let frame;
    function setDisabled(button, disabled) {
      if (button.disabled !== disabled) button.disabled = disabled;
      if (button.getAttribute('aria-disabled') !== String(disabled)) button.setAttribute('aria-disabled', String(disabled));
    }
    function update() {
      frame = null;
      if (!list.isConnected || !desktop.matches) return;
      setDisabled(prev, list.scrollTop <= 1);
      setDisabled(next, list.scrollTop + list.clientHeight >= list.scrollHeight - 1);
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    [prev, next].forEach((button) => {
      button.addEventListener('click', (event) => {
        if (!desktop.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const item = list.querySelector('.thumbnail-list__item');
        const gap = parseFloat(getComputedStyle(list).rowGap) || 0;
        const step = (item?.getBoundingClientRect().height || 75) + gap;
        list.scrollBy({ top: (button === next ? 1 : -1) * step,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, true);
    });
    list.addEventListener('scroll', schedule, { passive: true });
    list.addEventListener('load', schedule, true);
    // Observe content/size only. Watching our own button attributes creates a loop.
    const observer = new ResizeObserver(() => {
      if (!list.isConnected) { observer.disconnect(); return; }
      schedule();
    });
    observer.observe(list);
    schedule();
  }
  function init(root = document) {
    if (root.matches?.(selector)) setup(root);
    root.querySelectorAll(selector).forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('media-gallery:updated', (event) => init(event.target));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  desktop.addEventListener('change', () => {
    init();
    document.querySelectorAll(selector).forEach((gallery) => {
      if (desktop.matches) gallery.updateDesktopNavigation?.();
      else {
        gallery.elements?.viewer?.resetPages?.();
        gallery.elements?.thumbnails?.resetPages?.();
      }
    });
    document.querySelectorAll(selector + ' .thumbnail-list').forEach((list) => list.dispatchEvent(new Event('scroll')));
  });
})();
